import {AxiosResponse} from 'axios';

import core from './core';
import {FileData, IPriceQuote, WizardData} from '../lib/store/stores/wizard';
import {ApiResponse} from '../types/Wizard/types';

export const fetchPriceQuote = (data: WizardData): Promise<IPriceQuote> =>
  core.post('/bff/priceQuote', data).then((response: AxiosResponse<IPriceQuote>) => response.data);

export const postUploadedFile = (data: FormData): Promise<AxiosResponse<ApiResponse<FileData[]>>> =>
  core.post('/ajax/filepicker/fileUploaded', data);
